import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from '@execonline-inc/execonline-ui';
import * as React from 'react';
import { NotTranslated, T, TPlainTextKey } from '../../../Translations';

interface Props {
  isOpen: boolean;
  sectionLabel: TPlainTextKey;
  affected: number;
  withheld: number;
  disabling: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

// Turning a whole section off stops real messages, so it asks first and names
// the section and the count. The section name is a translation key, the same
// one the list heading uses, so the two always read alike. Only the count is
// rendered as data: parameterized plurals are unreliable under the current
// i18next (DVLP-7808).
const BulkDisableModal: React.FC<Props> = ({
  isOpen,
  sectionLabel,
  affected,
  withheld,
  disabling,
  onClose,
  onConfirm,
}) => (
  <Modal open={isOpen} onClose={onClose}>
    <ModalHeader className="w-full justify-between items-center">
      <Typography variant="subtitleLarge" fontWeight="semibold">
        {disabling ? (
          <T kind="Turn off these messages?" />
        ) : (
          <T kind="Turn these messages back on?" />
        )}
      </Typography>
    </ModalHeader>
    <ModalBody>
      <Typography variant="bodyMedium">
        {disabling ? (
          <T kind="Participants in this collection will stop receiving the messages in this section." />
        ) : (
          <T kind="Participants in this collection will start receiving the messages in this section again." />
        )}
      </Typography>
      <Typography variant="bodyMedium" fontWeight="semibold">
        <T kind={sectionLabel} />
        <NotTranslated text={` · ${affected}`} />
      </Typography>
      {withheld > 0 && (
        <Typography variant="bodyMedium">
          <T kind="Messages that cannot be turned off are left as they are." />
        </Typography>
      )}
    </ModalBody>
    <ModalFooter className="flex-row justify-end">
      <Button
        variant="text"
        color="secondary"
        onClick={onClose}
        data-intercom-target="communications-bulk-cancel-button"
      >
        <T kind="Cancel" />
      </Button>
      <Button onClick={onConfirm} data-intercom-target="communications-bulk-confirm-button">
        {disabling ? <T kind="Turn off" /> : <T kind="Turn back on" />}
      </Button>
    </ModalFooter>
  </Modal>
);

export default BulkDisableModal;
